import $axios from "../api/accessor";

const SLUG_TO_ENDPOINT: Record<string, string> = {
  // AZ
  "baglamalarin-dasinmasi": "packages-transportation",
  "kuryer-sifarisi":        "courier-order",
  "poct-sifarisi":          "post-order",
  "musteri-xidmetleri":     "customer-services",
  // EN
  "packages-transportation": "packages-transportation",
  "courier-order":           "courier-order",
  "post-order":              "post-order",
  "customer-services":       "customer-services",
  // RU
  "perevozka-bagazha":       "packages-transportation",
  "zakaz-kuriera":           "courier-order",
  "pochtovyy-zakaz":         "post-order",
  "obsluzhivanie-klientov":  "customer-services",
};

export const ServicesService = {
  async getServicePage(slug: string): Promise<string> {
    const endpoint = SLUG_TO_ENDPOINT[slug];
    if (!endpoint) throw new Error(`Unknown service slug: ${slug}`);
    const response = await $axios.get(endpoint);
    // Hər endpoint öz adı ilə key qaytarır: { "packages-transportation": "html" }
    return response.data?.[endpoint] || "";
  },
};
